export const LANGUAGES = {
  en: {
    code: 'en',
    label: 'ENGLISH (EN)',
    dir: 'ltr',
  },
  ar: {
    code: 'ar',
    label: 'ARABIC (AR)',
    dir: 'rtl',
  },
  cn: {
    code: 'cn',
    label: 'CHINESE (CN)',
    dir: 'ltr',
  },
};

export const DEFAULT_LANG = 'en';

export const SUPPORTED_LANGS = Object.keys(LANGUAGES);
